var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndenodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061E37",
    d: "M1.63636364,2.79344746 L1.63636364,9.81818182 L8.66109799,9.81818182 L1.63636364,2.79344746 Z M9.81818182,8.66109799 L9.81818182,1.63636364 L2.79344746,1.63636364 L9.81818182,8.66109799 Z M11.4545455,10.2974616 L11.4876328,10.330549 L11.4545455,10.3636364 L11.4545455,10.9090909 C11.4545455,11.2103371 11.2103371,11.4545455 10.9090909,11.4545455 L10.3636364,11.4545455 L10.330549,11.4876328 L10.2974616,11.4545455 L0.545454545,11.4545455 C0.244208318,11.4545455 -5.41419916e-14,11.2103371 -5.41788836e-14,10.9090909 L-5.41788836e-14,0.545454545 C-5.42157756e-14,0.244208318 0.244208318,2.71987329e-15 0.545454545,2.66453526e-15 L10.9090909,2.66453526e-15 C11.2103371,2.60919722e-15 11.4545455,0.244208318 11.4545455,0.545454545 L11.4545455,10.2974616 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndenodeIcon);
export default __webpack_public_path__ + "static/media/indenode-icon.658b0e821c3cb7f77778fc497c8cea16.svg";
export { ForwardRef as ReactComponent };